////////////////////////////////////////////////////////////////////////////////////////////////
//                                                                                            //
//                       Dashboard page functionality done over here.                         //
//                                                                                            //
////////////////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect, useContext } from "react";
import { Row, Container } from "reactstrap";
import ExcelExportButton from "../../components/common/excelConverter/ExcelConverter";
import { getDashboardDetails } from '../../api/dashboardApi';
import { AuthContext } from "../../contexts/AuthContext";
// Breadcrumb
import Breadcrumbs from "../../components/common/Breadcrumb";

import UsePanel from "./UserPanel";
import OrderStatus from "./OrderStatus";
import OverView from "./OverView";
// import LatestTransation from "./LatestTransation";
import { useAppSettings } from '../../contexts/AppSettingsContext';

const Dashboard = () => {
  const { appSettings } = useAppSettings();
  const appName = appSettings?.title || process.env.REACT_APP_APP_NAME;
  const { authToken } = useContext(AuthContext);
  const [dashboardDetails, setDashboardDetails]  = useState([])

  useEffect(()=>{
    fetchDashBoardDetails()
  },[authToken])
  const fetchDashBoardDetails =async ()=>{
    try{
        const response = await getDashboardDetails(authToken)
        if (response?.code == 200) {
          setDashboardDetails(response?.data || []);
        }
    }catch(err){
      console.log("err", err);
      
    }
  }

  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={appName}
            breadcrumbItem="Dashboard"
          />
          {/* User Panel Charts */}
          <UsePanel  dashboardDetails={dashboardDetails}/>
          <Row>
            <OverView />
            <OrderStatus />
          </Row>
          <Row></Row>
          {/* <ExcelExportButton /> */}
          {/* Latest Transaction Table */}
          {/* <LatestTransation /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
